import { render, staticRenderFns } from "./lateral.vue?vue&type=template&id=1eaf2fa5&"
import script from "./lateral.vue?vue&type=script&lang=js&"
export * from "./lateral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports